import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getDisclaimerMessageStyles } from './styles/disclaimer-message';

export const DisclaimerMessage = ({
  disclaimerMessage,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getDisclaimerMessageStyles({ styleOverrides: styleOverrides.disclaimerMessage }));

  if (disclaimerMessage) {
    return (
      <div className={classnames('disclaimer-info', classes.disclaimerInfo)}>
        <div className={classnames('disclaimer-info-inline', classes.disclaimerInfoInline)}>
          {disclaimerMessage}
        </div>
      </div>
    );
  }

  return null;
};

DisclaimerMessage.propTypes = {
  disclaimerMessage: PropTypes.string,
  styleOverrides: PropTypes.shape({
    disclaimerMessage: PropTypes.shape({}),
  }),
};

DisclaimerMessage.defaultProps = {
  disclaimerMessage: '',
  styleOverrides: {},
};
